import Table from "../components/Table";
import Sidebar from "../../../components/partials/Sidebar";
import Header from "../../../components/partials/Header";
import Breadcrumb from "../../../components/Breadcrumb";
import { useEffect, useRef, useState } from "react";
import $ from "jquery";
import config from "../../../config";
import Pagination from "../../../components/Pagination";
import filterIcon from "../../../images/icons/filter.png";
import "../style.css";
import Swal from "sweetalert2";
import moment from "moment";
import Tippy from "@tippyjs/react";
import Filter from "../components/Filter";
import ExcelDownload from "../components/ExcelDownload";
import { millionComma } from "../../../utils";

const PaymentMovement = (props) => {
  const [user, setUser] = useState({});
  const [pageSize, setPageSize] = useState(10);

  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  const getBranchList = async (inputValue, callback) => {
    let branches = props.branchList.filter((b) =>
      b.label
        .toString()
        .toLowerCase()
        .includes(inputValue.toString().toLowerCase()),
    );
    callback(branches);
  };

  const getLedgerList = async (inputValue, callback) => {
    let paymentMode = config.paymentMode.filter((b) =>
      b.label
        .toString()
        .toLowerCase()
        .includes(inputValue.toString().toLowerCase()),
    );
    callback(paymentMode);
  };

  const isMounted = useRef(false);

  const filterList = [
    {
      name: "branch_id",
      label: "Branch Name",
      type: "async_select",
      visible: [1, 2].includes(user.role_id),
      values: getBranchList,
    },
    {
      name: "payment_mode_id",
      label: "Payment Mode",
      required: true,
      type: "async_select",
      values: getLedgerList,
    },
    { name: "from_date", label: "From Date", type: "date", required: true },
    { name: "to_date", label: "To Date", type: "date", required: true },
  ];

  const columnList = [
    {
      label: "Branch Name",
      value: "branch_name",
      visible: [1, 2].includes(user.role_id),
    },
    { label: "Description", value: "desc", visible: true },
    { label: "Type", value: "tran_type", visible: true },
    // { label: "Amount", value: "trans_amount", visible: true },
    // { label: "", value: "trans_amount_modal", visible: false },
    { label: "Cr Amount", value: "cr_amount", visible: true },
    { label: "", value: "cr_amount_modal", visible: false },
    { label: "Dr Amount", value: "dr_amount", visible: true },
    { label: "", value: "dr_amount_modal", visible: false },
    { label: "Trans ID", value: "fid_1", visible: true },
    { label: "Trans Date", value: "trans_date", visible: true },
    { label: "", value: "is_active", visible: false },
  ];

  const [filter, setFilter] = useState(() => {
    let filters = {};
    filterList.forEach((list) => {
      if (list.name === "from_date" || list.name === "to_date") {
        filters[list.name] = moment().format("YYYY-MM-DD");
      } else {
        filters[list.name] = "";
      }
    });
    return filters;
  });
  const [column, setColumn] = useState(() => columnList);
  useEffect(() => {
    setColumn(() => columnList);
  }, [user]);
  const [row, setRow] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [showFilter, setShowFilter] = useState(true);
  const [showLoading, setShowLoading] = useState(false);

  const [closingBal, setClosingBal] = useState("");
  const [openningBal, setOpenningBal] = useState("");
  const [credit, setCredit] = useState("");
  const [debit, setDebit] = useState("");

  const getList = async () => {
    if (!filter?.payment_mode_id) {
      Swal.fire("Error", "Payment Mode is Required");
      return;
    }

    if (!filter?.from_date || !filter?.to_date) {
      Swal.fire("Error", "Date is Required");
      return;
    }

    if (
      user?.role_id === 3 ||
      user?.role_id === 4 ||
      user?.role_id === 9 ||
      user?.role_id === 8
    ) {
      filter.branch_id = JSON.parse(
        localStorage.getItem("inventory"),
      )?.userData?.branch_data?.[0]?.branch_id;
    }

    if (!filter?.branch_id && user?.role_id != 9) {
      Swal.fire("Error", "Branch is Required");
      return;
    }

    setShowLoading(true);
    await $.post(
      `${config.apiUrl}/report/listPaymentMovement`,
      JSON.stringify({
        ...filter,
        paginate: 1,
        is_active: 1,
        page_no: currentPage - 1,
        page_size: pageSize,
      }),
    )
      .done((res) => {
        setClosingBal(res?.data.totalAmount.closing_balance);
        setOpenningBal(res?.data.totalAmount.opening_balance);
        setCredit(res?.data.totalAmount.total_credit);
        setDebit(res?.data.totalAmount.total_debit);

        if (res?.data?.list?.length > 0) {
          let cols = columnList.map((col) => col.value);
          const payDtl = JSON.stringify([
            { mode: "Cash UGX", conv: 1, conv_amt: 0, amt: 0 },
            { mode: "USD", conv: 1, conv_amt: 0, amt: 0 },
            { mode: "Momo Pay", conv: 1, conv_amt: 0, amt: 0 },
            { mode: "Airtel Money", conv: 1, conv_amt: 0, amt: 0 },
          ]);
          setRow(() => {
            let resArr = res?.data?.list || [];
            let tranType = [
              "Opening",
              "Challan",
              "Expense",
              "Income",
              "Challan Rtn",
              "Purchase",
              "Purchase Rtn",
              "Cash Withdraw",
              "Closing",
            ];
            let arr = [];
            resArr.forEach((r, i) => {
              // if (r?.payment_mode_id < 2) {
              if (i + (currentPage - 1) * 10 === 0) {
                arr.push({
                  branch_name: r?.branch_name || "",
                  desc: "Opening Balance",
                  tran_type: tranType?.[0] || "",
                  trans_amount: millionComma(r?.op_bal || 0),
                  trans_amount_modal: r?.op_bal_modal || payDtl,
                  cr_amount: millionComma(r?.op_bal || 0),
                  cr_amount_modal: r?.op_bal_modal || payDtl,
                  dr_amount: "",
                  dr_amount_modal: "",
                  tran_id: "",
                  fid_1: "",
                  trans_date: moment(r?.trans_date)?.format("DD-MM-YYYY"),
                });
              }
              // }
              arr.push({
                branch_name: r?.branch_name || "",
                desc: r?.party_name || "",
                tran_type: tranType?.[r?.tran_type] || "",
                trans_amount: millionComma(r?.trans_amount || 0),
                trans_amount_modal: r?.trans_amount_modal || payDtl,
                cr_amount:
                  r?.cr_amount > 0 ? millionComma(r?.cr_amount || 0) : "0",
                cr_amount_modal: r?.cr_amount > 0 ? r?.trans_amount_modal : "0",
                dr_amount:
                  r?.dr_amount > 0 ? millionComma(r?.dr_amount || 0) : "0",
                dr_amount_modal: r?.dr_amount > 0 ? r?.trans_amount_modal : "0",
                tran_id: r?.tran_id || "",
                fid_1: r?.fid_1 || "",
                trans_date: moment(r?.trans_date)?.format("DD-MM-YYYY"),
                is_active: r?.is_active,
              });
              // if (r?.payment_mode_id < 2) {
              if (i + (currentPage - 1) * 10 === res?.data?.count - 1) {
                arr.push({
                  branch_name: r?.branch_name || "",
                  desc: "Closing Balance",
                  tran_type: tranType?.[8],
                  trans_amount: millionComma(r?.cl_bal || 0),
                  trans_amount_modal: r?.cl_bal_modal || payDtl,
                  cr_amount: millionComma(r?.cl_bal || 0),
                  cr_amount_modal: r?.cl_bal_modal || payDtl,
                  dr_amount: "",
                  dr_amount_modal: "",
                  tran_id: "",
                  fid_1: "",
                  trans_date: moment(filter?.to_date || r?.trans_date)?.format(
                    "DD-MM-YYYY",
                  ),
                });
              }
              // }
            });
            return arr;
          });
          setTotalPage(() => res?.data?.count || 0);
          setCurrentPage(() => currentPage);
        } else {
          setTotalPage(() => 0);
          setCurrentPage(() => 1);
          setRow(() => []);
        }
        setShowLoading(false);
      })
      .fail((err) => {
        Swal.fire(
          "",
          err?.responseJSON?.data?.message || err?.responseJSON?.message,
        );
        setShowLoading(false);
      });
  };

  const clearList = () => {
    setFilter(() => {
      let filters = {};
      filterList.forEach((list) => {
        filters[list.name] = "";
      });
      return filters;
    });
    setTotalPage(() => 0);
    setCurrentPage(() => 1);
    setRow(() => []);
  };

  const validateDownload = (filter) => {
    if (!filter?.payment_mode_id) {
      Swal.fire("Error", "Payment Mode is Required");
      return false;
    }

    if (!filter?.from_date || !filter?.to_date) {
      Swal.fire("Error", "Date is Required");
      return false;
    }

    return true;
  };

  useEffect(() => {
    if (isMounted.current) getList();
    isMounted.current = true;
  }, [currentPage]);

  const changePageSize = (e) => {
    const newSize = e.target.value;
    setPageSize(newSize);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (row.length > 0) {
      getList();
    }
  }, [pageSize]);

  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div className="content m-1 p-2">
          <Header />
          <main className="bg-white rounded-2" id="ledger">
            <div className="container-fluid p-2">
              <div className="row">
                <div className="col-md">
                  <Breadcrumb path={["Cash Movement"]} />
                </div>

                <div className="col-md text-end">
                  <select value={pageSize} onChange={(e) => changePageSize(e)}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <Tippy content="Filter" trigger="mouseenter">
                    <img
                      src={filterIcon}
                      className="img-fluid mx-2 icon"
                      width="35px"
                      height="35px"
                      alt=""
                      role="button"
                      onClick={(e) => setShowFilter(!showFilter)}
                    />
                  </Tippy>

                  <ExcelDownload
                    validate={validateDownload}
                    filter={filter}
                    filename="CashMovement"
                    url={`${config.apiUrl}/report/listPaymentMovement`}
                  />
                </div>
              </div>

              <Filter
                show={showFilter}
                filterList={filterList}
                showLoading={showLoading}
                handler={{ getList, clearList, state: { filter, setFilter } }}
              />

              <Table tableData={{ column, row }} handler={{ getList }} />

              <div className="row mt-4 ">
                <div className="row mt-4">
                  <div className="col-6">
                    <p>
                      <b>Opening Balance:</b> {millionComma(openningBal)}
                    </p>
                    <p>
                      <b>Total Debit:</b> {millionComma(debit)}
                    </p>
                    <p>
                      <b>Total Credit:</b> {millionComma(credit)}
                    </p>
                    <p>
                      <b>Closing Balance:</b> {millionComma(closingBal)}
                    </p>
                  </div>
                </div>

                <div className="col-6">
                  <Pagination
                    nPages={Math.ceil(totalPage / Number(pageSize))}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default PaymentMovement;
